import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import cnJSON from "./locale/cn.json";
import ruJSON from "./locale/ru.json";
import { store } from "./redux/store";

const updateLanguage = () => {
  const currentLanguage = store.getState().cars.lang || "ru";
  i18n.changeLanguage(currentLanguage);
};

store.subscribe(() => {
  updateLanguage();
});

i18n.use(initReactI18next).init({
  resources: {
    cn: { ...cnJSON },
    ru: { ...ruJSON },
  },
  lng: store.getState().cars.lang,
  fallbackLng: "ru",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
